
import React, {FC, useEffect} from 'react';
import {useAspectRatio} from 'templates/reports/Section/ScanImages/useAspectRatio';
import {ImageConfig} from 'templates/reports/Section/ScanImages/useColors';
import {decode} from 'templates/reports/Section/ScanImages/useImages/decode';
import {Images} from 'templates/reports/Section/ScanImages/useImages/query';
import {useVisible} from 'templates/reports/Section/ScanImages/useVisible';

import * as styles from 'templates/reports/Section/ScanImages/styles.module.scss';

type CanvasSingleProps = {
	canvas: React.RefObject<HTMLCanvasElement>
	image: Images['images']['0']
	config: ImageConfig
}

const CanvasSingle: FC<CanvasSingleProps> = ({canvas, image, config}) => {
	const isVisible = useVisible(canvas);

	useEffect(() => {
		const ctx = canvas.current?.getContext('2d');
		if (!ctx || !isVisible) {
			return;
		}

		ctx.clearRect(0, 0, image.width, image.height);
		decode(image, (x, y, v) => {
			if (v > 0) {
				ctx.fillStyle = config.fillStyle(v);
				ctx.fillRect(x, y, 1, 1);
			}
		});
	}, [canvas.current, config.color, isVisible]);

	const style = useAspectRatio(image);
	return (
		<div className={styles.canvasWrapper} style={config.style}>
			<canvas
				ref={canvas}
				width={image.width}
				height={image.height}
				style={style}
			/>
		</div>
	);
};

export default CanvasSingle;
